import React from "react";

import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddCompany() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          บริษัท
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Company
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Create Company
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            company_code: "",
            company_no: "",
            company_name: "",
            address: "",
            telephone: "",
            fax: "",

            remark: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.company_code || values.company_code === "") {
              errors.company_code = "Company Code Required";
            }
            if (!values.company_name || values.company_name === "") {
              errors.company_name = "Company Name Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                code: values.company_code,
                no: values.company_no,
                name: values.company_name,
                address: values.address,
                phone: values.telephone,
                fax: values.fax,
                remark: values.remark,
                status: 1,
                createId: EmpId,
              };

              api
                .post("api/company/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มบริษัทสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Company");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      name="company_code"
                      // label="Customer Code"
                      label="Company Code"
                      variant="outlined"
                      placeholder="Company"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_code}
                      classes={{ root: !values.company_code ? classes.customOutline :null }}
                    />

                    <TextField
                      name="company_no"
                      label="Company No"
                      variant="outlined"
                      placeholder="Company No"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_no}
                      classes={{ root: !values.company_no ? classes.customOutline :null }}

                    />
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="company_name"
                      label="Company Name"
                      variant="outlined"
                      placeholder="Company Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_name}
                      classes={{ root: !values.company_name ? classes.customOutline : null }}
                    />

                    <TextField
                      name="telephone"
                      label="Telephone"
                      variant="outlined"
                      placeholder="Telephone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.telephone}
                    />
                    {errors.telephone && touched.telephone && errors.telephone}
                    <TextField
                      name="fax"
                      label="Fax"
                      variant="outlined"
                      placeholder="Fax"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.fax}
                    />
                    {errors.fax && touched.fax && errors.fax}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <TextField
                      name="address"
                      label="Address"
                      variant="outlined"
                      placeholder="Address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.address}
                      fullWidth
                    />
                    {errors.address && touched.address && errors.address}
                  </div>

                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <TextField
                      fullWidth
                      rows={3}
                      multiline={true}
                      label="Remark *"
                      placeholder="Remark"
                      InputLabelProps={{ shrink: true }}
                      name="remark"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.remark}
                    />
                    {errors.remark && touched.remark && errors.remark}
                  </div>
                </Grid>
              </Grid>

              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
